/* global axios */
import ApiClient from '../ApiClient';

class InternalChatConversations extends ApiClient {
  constructor() {
    super('internal_chat_conversations', { accountScoped: true });
  }

  markDelivered(conversationId) {
    return axios.post(`${this.url}/${conversationId}/delivered`);
  }

  markRead(conversationId) {
    return axios.post(`${this.url}/${conversationId}/read`);
  }
}

export default new InternalChatConversations();
